import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { AllGradeSuggestionResponse, GradeSuggestionResponse} from '@gtpl/shared-models/masters';
import { Body, Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { getManager, Raw, Repository } from 'typeorm';
import { GradeSuggestionAdapter } from './dto/grade-suggestion.adapter';
import { GradeSuggestionDTO } from './dto/grade-suggestion.dto';
import { GradeSuggestion } from './grade-suggestion.entity';
import { LogActions, LoggerInstantiation } from 'apps/services/logger/logger-functions';
import { GradeSuggestionRequest } from './dto/grade-suggestion.request';
import appSettings from 'apps/services/config';
import { GradeSequenceModel } from './dto/grade-sequence-model';
import { CommonResponse } from '@gtpl/shared-models/production-management';
const gradeSuggestionTable = appSettings.masters_db + '.grade_suggestion'
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
let moment = require('moment');
moment().format();
import { Cron } from '@nestjs/schedule';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';



@Injectable()
export class GradeSuggestionService {
    constructor(
      private logService:LogsService,
        @InjectRepository(GradeSuggestion) private gradeSuggestionRepository: Repository<GradeSuggestion>,
        private gradeSuggestionAdapter: GradeSuggestionAdapter,
      ) { }
      
      async createGradeSuggestion(dto: GradeSuggestionDTO, isUpdate: boolean,request:Request): Promise<GradeSuggestionResponse> {
          try {
          // console.log(isUpdate); 
          //this section will be executed while creating a new user only
          if (!isUpdate) {
            // console.log(isUpdate); 
    
              const GradeSuggestionEntity = await this.getDuplicateGradeSuggestion(dto.minGrade,dto.maxGrade,dto.saleOrderId);
              // console.log(GradeSuggestionEntity);
            if (GradeSuggestionEntity) {
             
              // return true;
              throw new ErrorResponse(11104, 'Grade Suggestion already exists');
            }
          }
          else{
            const GradeSuggestionEntity = await this.getDuplicateGradeSuggestion(dto.minGrade,dto.maxGrade,dto.saleOrderId);
            if(GradeSuggestionEntity){
                if(GradeSuggestionEntity.gradeSuggestionId!=dto.gradeSuggestionId) {
                    throw new ErrorResponse(11104, 'Grade Suggestion already exists');      
                }
            }
        }
          const convertedGradeSuggestionEntity: GradeSuggestion = this.gradeSuggestionAdapter.convertDtoToEntity(dto,isUpdate);
          const savedFoodEntity: GradeSuggestion = await this.gradeSuggestionRepository.save(convertedGradeSuggestionEntity);
          const savedGradeSuggestionDto: GradeSuggestionDTO = this.gradeSuggestionAdapter.convertEntityToDto(savedFoodEntity);
         
           if (savedGradeSuggestionDto) {
            const response = new GradeSuggestionResponse(true,isUpdate ? 11100 : 11101,isUpdate? 'Grade Suggestion Updated Successfully':'Grade Suggestion Created Successfully',savedGradeSuggestionDto);
            const name=isUpdate?'updated':'created'
            const newLogDto = new LogsDto(1,name, 'GradeSuggestion', savedGradeSuggestionDto.gradeSuggestionId, true, '',savedGradeSuggestionDto.createdUser)
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
            
            return response;
          } else {
            throw new ErrorResponse(11106,'Grade Suggestion saved but issue while transforming into DTO');
          }
        }
        catch (error) {
          throw error;
        }
      }

         /**
     * gets all  procurement types details  
     * @returns all the procurement type details .
     */
  // @LogActions({ isAsync: true })
  // async getAllGradeSuggestions(): Promise<AllGradeSuggestionResponse> {  
  //   try {
  //     const GradeSuggestionDtos: GradeSuggestionDTO[] = [];
  //     // retrieves all plants
  //     const GradeSuggestionEntities: GradeSuggestion[] = await this.gradeSuggestionRepository.find({
  //       order: { gradeSuggestionId: "ASC" },
  //     });
  //   //   console.log(GradeSuggestionEntities);
  //     if (GradeSuggestionEntities.length>0) {
  //       GradeSuggestionEntities.forEach(GradeSuggestionEntity => {
  //         const convertedGradeSuggestionDto: GradeSuggestionDTO = this.gradeSuggestionAdapter.convertEntityToDto(GradeSuggestionEntity);
  //         GradeSuggestionDtos.push(convertedGradeSuggestionDto);
  //       });
  //       const response = new AllGradeSuggestionResponse(true, 11208, "Grade Suggestions retrieved successfully", GradeSuggestionDtos);
  //       return response;
  //     } else {
  //       //   console.log('yest')
  //       throw new ErrorResponse(99998, 'No Records Found');
  //     }
  //   } catch (err) {
  //     throw err;
  //   }
  // }

  async getAllActiveGradeSuggestions(): Promise<AllGradeSuggestionResponse> {
    // const page: number = 1;
    try {
        const GradeSuggestionDtos: GradeSuggestionDTO[] = [];
        //retrieves all companies
        const GradeSuggestionEntities: GradeSuggestion[] = await this.gradeSuggestionRepository.find({ order: { gradeSuggestionId: 'ASC' },where:{isActive:true},
       });
     console.log(GradeSuggestionEntities)
        if (GradeSuggestionEntities) {
            // converts the data fetched from the database which of type companies array to type StateDto array.
            GradeSuggestionEntities.forEach(GradeSuggestionEntity => {
                const convertedGradeSuggestionDto: GradeSuggestionDTO = this.gradeSuggestionAdapter.convertEntityToDto(
                  GradeSuggestionEntity
                );
                GradeSuggestionDtos.push(convertedGradeSuggestionDto);
            });
            const response = new AllGradeSuggestionResponse(true, 11108, "GradeSuggestions retrieved successfully", GradeSuggestionDtos);
            return response;
        } else {
            throw new ErrorResponse(99998, 'Data not found'); GradeSuggestionDtos
        }
    } catch (err) {
        throw err;
    }
}  

       /**
     * It deactivates Grade Suggestion 
     * @param GradeSuggestionRequest Grade Suggestion  as string
     * @returns true or false
     */
    // @LogActions({isAsync: true})
    async activateOrDeactivateGradeSuggestion(GradeSuggestionRequest: GradeSuggestionRequest): Promise<GradeSuggestionResponse>{
        try {
            const GradeSuggestionExists = await this.getGradeSuggestionById(GradeSuggestionRequest.gradeSuggestionId);
            if (GradeSuggestionExists) {
                if (GradeSuggestionRequest.versionFlag !== GradeSuggestionExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current Grade Suggestion information.Refresh and try again');
                } else {
                    
                        const GradeSuggestionSatatus =  await this.gradeSuggestionRepository.update(
                            { gradeSuggestionId: GradeSuggestionRequest.gradeSuggestionId },
                            { isActive: GradeSuggestionRequest.isActive,updatedUser: GradeSuggestionRequest.updatedUser });
                       
                        if (GradeSuggestionExists.isActive) {
                            if (GradeSuggestionSatatus.affected) {
                                const gradeSuggestionResponse: GradeSuggestionResponse = new GradeSuggestionResponse(true, 10115, 'Grade Suggestion is de-activated successfully');
                                return gradeSuggestionResponse;
                            } else {
                                throw new ErrorResponse(10111, 'Grade Suggestion is already deactivated');
                            }
                        } else {
                            if (GradeSuggestionSatatus.affected) {
                                const gradeSuggestionResponse: GradeSuggestionResponse = new GradeSuggestionResponse(true, 10114, 'Grade Suggestion is activated successfully');
                                return gradeSuggestionResponse;
                            } else {
                                throw new ErrorResponse(10112, 'Grade Suggestion is already  activated');
                            }
                        }
                    // }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }

    async getGradeSuggestions(gradeSuggestionId: number): Promise<GradeSuggestion> {
     const gradeSuggestionRes = await this.gradeSuggestionRepository.findOne({
          where: {gradeSuggestionId: Raw(alias => `grade_suggestion_id = '${gradeSuggestionId}'`)},
        });
        // console.log(gradeSuggestionRes);
        if (gradeSuggestionRes) {
        return gradeSuggestionRes;
        } else {
        return null;
        }
    }

    async getDuplicateGradeSuggestion(minGrade: number,maxGrade:number,saleOrderId:number): Promise<GradeSuggestion> {
      //  console.log(employeeId);
          const response = await this.gradeSuggestionRepository.findOne({
          where: {minGrade: minGrade,maxGrade:maxGrade,saleOrderId:saleOrderId},
          });
          // console.log(response);
          if (response) {
          return response;
          } else {
          return null;
          }
      }

    async getGradeSuggestionById(gradeSuggestionId: number): Promise<GradeSuggestion> {
        const gradeSuggestionRes = await this.gradeSuggestionRepository.findOne({
        where: {gradeSuggestionId: gradeSuggestionId},
        });
        // console.log(gradeSuggestionRes);
        if (gradeSuggestionRes) {
        return gradeSuggestionRes;
        } else {
        return null;
        }
    }

    async getGradeSuggestionDataById(@Body() GradeSuggestionRequest:GradeSuggestionRequest): Promise<GradeSuggestionResponse> {
      // const page: number = 1;
      try {
        const GradeSuggestionDTO: GradeSuggestionDTO[] = [];
        //retrieves all companies
        const GradeSuggestionEntities: GradeSuggestion = await this.gradeSuggestionRepository.findOne({
          //   relations:["CusAddressInfo"],
          where:{gradeSuggestionId:GradeSuggestionRequest.gradeSuggestionId}
          });
          
          const GradeSuggestionsData: GradeSuggestionDTO = this.gradeSuggestionAdapter.convertEntityToDto(GradeSuggestionEntities);
          if (GradeSuggestionsData) {
              const response = new GradeSuggestionResponse(true, 11101 , 'Grade Suggestion retrived Successfully',GradeSuggestionsData);
              return response;
          }
          else{
              throw new ErrorResponse(11106,'Something went wrong');
          }
          // generating resposnse
          
      } catch (err) {
        throw err;
      }
    }


    async getAllGradeSuggestions(): Promise<AllGradeSuggestionResponse> {
      try {
          const manager = getManager()
          const query = `SELECT s.saleOrder_id as saleOrderId,s.date as date,s.grade_suggestion_id as gradeSuggestionId,s.min_grade as minGrade,s.max_grade as maxGrade,so.po_number as poNumber,s.product_id as productId,sk.variant_code as product,s.priority as priority,s.planned_qty as plannedQuantity,s.plant_id as plantId,s.sequence as sequence,ot.container_status as containerStatus FROM ` + gradeSuggestionTable + ` s
          LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details so ON so.sale_order_id=s.saleOrder_Id
          LEFT JOIN ` + appSettings.masters_db + `.sku_codes sk ON sk.sku_code_id=s.product_id 
          LEFT JOIN ` + appSettings.sales_db + `.sale_order_track ot ON ot.so_track_id=s.saleOrder_id
          WHERE ot.container_status != 'SHIPPED' ORDER BY  sequence ASC` 
          const qEntities: GradeSuggestion[] = await manager.query(query)
          if (qEntities) {

              const response = new AllGradeSuggestionResponse(true, 1, 'Data retrieved successfully', qEntities);
              const newLogDto = new LogsDto(1,'view', 'GradeSuggestion', 0, true, '','')
              let res = await this.logService.createLog(newLogDto);
              console.log(res);
              return response;
          } else {
              throw new ErrorResponse(99998, 'Data Not Found');
          }
      } catch (err) {
          console.log(err)
          return err;
      }
  }

  async updateGradeSuggestion(req:GradeSequenceModel[]):Promise<CommonResponse> {
      try{
          const gradeSuggItems:GradeSequenceModel[] = req;
          const updateFlagSet = new Set<boolean>();
          for(const reqItem of gradeSuggItems){
              console.log(reqItem,'gradeSuggestionId')
              const gradeSuggestionUpdate = await this.gradeSuggestionRepository.update({gradeSuggestionId:reqItem.gradeSuggestionId},{plannedQuantity:reqItem.plannedQuantity,sequence:reqItem.sequence,priority:reqItem.priority})
              if(gradeSuggestionUpdate.affected){
                updateFlagSet.add(true)
            }else{
                updateFlagSet.add(false)
                return new CommonResponse(false,11111,'Something went wrong in updation')
            }
        }
        if(!(updateFlagSet.has(false))){
            return new CommonResponse(true,11111,'Updated Successfully')
            
        }else{
              return new CommonResponse(false,11111,'Something went wrong in updation')

          }

        }catch(err){
            return new CommonResponse(false,11111,err)
      }

  }
 
  @Cron('55 23 * * *')
  async insertData(){
      try{
        let currentDate = moment().format('YYYY-MM-DD')
        let tommorowDate = moment(currentDate).add(1,'days')
      
        const todaysData: GradeSuggestion[]= await this.gradeSuggestionRepository.find({ order: { gradeSuggestionId: 'ASC' },where:{date:currentDate}}); 
        let result
        for(const iterator of todaysData){
           const gradeSuggestionEntity = new GradeSuggestion()
           gradeSuggestionEntity.date =tommorowDate.format('YYYY-MM-DD')
           gradeSuggestionEntity.plantId = iterator.plantId;
           gradeSuggestionEntity.minGrade = iterator.minGrade;
           gradeSuggestionEntity.maxGrade = iterator.maxGrade;
           gradeSuggestionEntity.saleOrderId = iterator.saleOrderId;
           gradeSuggestionEntity.productId = iterator.productId;
           gradeSuggestionEntity.plannedQuantity = iterator.plannedQuantity;
           gradeSuggestionEntity.priority = iterator.priority;
           gradeSuggestionEntity.createdUser = iterator.createdUser;
           gradeSuggestionEntity.createdAt = iterator.createdAt;
       
           result = await this.gradeSuggestionRepository.save(gradeSuggestionEntity);
        }
        if(result){
        return 'data inserted'
            
        }else{
            return 'data not inserted'
        }
       
      }

      catch(err ){
          return err
      }
  }


}


